module.exports = __webpack_public_path__ + "static/media/Union-1.c8d73cc2.svg";